var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLowEnergy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.568 16.75l-9.223 2.016 4.51-15.791c.392-1.373-1.444-2.252-2.266-1.083L1.599 27.45c-.676.961.206 2.25 1.346 1.97l8.218-2.023-4.495 15.807c-.387 1.362 1.416 2.23 2.249 1.107l18.947-25.559c.699-.943-.149-2.253-1.296-2.002zm-15.54 20.435l3.185-11.2a1.274 1.274 0 00-1.53-1.586l-7.042 1.734L17.338 9.515l-3.027 10.601c-.264.923.553 1.8 1.496 1.594l7.987-1.746-12.766 17.22z",
    fill: "#91C300",
    stroke: "#91C300"
  })));
}

export default SvgLowEnergy;